import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

if (location.hostname === 'localhost' || location.hostname === '192.168.178.43') {} else {
  if (location.protocol != 'https:') {
    location.href = 'https:' + window.location.href.substring(window.location.protocol.length)
  }
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
